import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoText from './LogoText';
import Button from './Button';
import Footer from './Footer';
import kofiImage from '../assets/images/kofi.webp';

function Menu() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="flex flex-col items-center justify-center flex-grow">
        <div className="animate-slideDownStaggered">
          <LogoText text="Wall Go" />
        </div>

        <div className="p-6 rounded-lg bg-transparent">
          <div className="space-y-4 flex flex-col items-center w-52">
            <div className="animate-slideDownStaggered animate-delay-200 w-full">
              <Button onClick={() => navigate('/play/ai')} className="w-full">
                Play vs AI
              </Button>
            </div>
            <div className="animate-slideDownStaggered animate-delay-200 w-full">
              <Button onClick={() => navigate('/play/2player')} className="w-full">
                Play vs Player
              </Button>
            </div>
            <div className="animate-slideDownStaggered animate-delay-400 w-full">
              <Button onClick={() => navigate('/instructions')} className="w-full">
                Instructions
              </Button>
            </div>
            <div className="animate-slideDownStaggered animate-delay-400 w-full">
              <Button onClick={() => navigate('/about')} className="w-full">
                About
              </Button>
            </div>
            <div className="animate-slideDownStaggered animate-delay-600 w-full">
              <Button
                onClick={() => window.open('https://ko-fi.com/tetedanslesclouds', '_blank', 'noopener,noreferrer')}
                className="w-full"
              >
                <div className="flex items-center justify-center gap-2">
                  <img src={kofiImage} alt="" className="mt-0.5 h-5 w-auto" aria-hidden />
                  <span>Support</span>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Menu; 
